import React, { useMemo } from 'react';

import { NavItem } from 'components/NavBar/interfaces';

import Hamburger from './Hamburger';
import Menu from './Menu';
import Shade from './Shade';
import { SideNavProvider } from './context';
import { ComponentProps, MenuItem } from './interfaces';
import * as Styled from './styled';

const mapNavItemsToMenuItems = (items: NavItem[], level = 0): MenuItem[] => {
  return items.map(({ id, text, href, subItems }) => ({
    id,
    text,
    href,
    itemLevel: level,
    state: 'Collapsed',
    ...(subItems
      ? {
          subItems: mapNavItemsToMenuItems(subItems, level + 1)
        }
      : null)
  }));
};

export const SideNav: React.FC<ComponentProps> = ({ isOpen, items = [], ...menuProps }) => {
  const menuItems = useMemo(() => mapNavItemsToMenuItems(items), [items]);

  return (
    <SideNavProvider isOpen={!!isOpen} items={menuItems}>
      <Styled.Wrapper>
        <Hamburger />
        <Menu {...menuProps} />
        <Shade />
      </Styled.Wrapper>
    </SideNavProvider>
  );
};

export default SideNav;
